<template>
  <div>
    <!-- <v-toolbar flat class="mt-6">
      <v-combo class="ml-2" v-model="curWhs" v-bind="whsCombo"></v-combo>
    </v-toolbar> -->
    <!-- curWhs:{{ curWhs }} -->
    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :getItemColor="getItemColor"
      :tableKey="tableKey"
      :onDataReceived="onDataReceived"
      :defaultTab="activeTab"
      :noDelete="true"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapLegend="mapLegend"
      :editable="editable"
      :onMarkerClick="onMarkerClick"
      :showGroupBy="true"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :isDraggable="tableDraggable"
      :objKey="objKey"
      :mapLoading="mapLoading"
      :customSort="customSort"
      :showFullTable="true"
      :customSortItems="customSortItems"
      :customFilter="customFilter"
      :tableName="tableName"
      :tableTitle="tableTitle"
      :editRow="false"
      :editedItemTitle="editedItemTitle"
      :calToolBarControls="calToolBarControls"
      :calendarFilter="calendarFilter"
      :filterTabsFn="filterTabsFn"
      :hideAllTabFilter="false"
      :actionCommand="actionCommand"
      :itemsPerPage="100"
      :coloredFields="coloredFields"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
import { resolve } from "path";
export default {
  name: "LocalDispatch",
  components: {
    // VCombo: () => import("../components/ComboBox.vue"),
    VCalTblMap: () => import("../components/CalTblMap.vue")
    // VDateRangePicker: () => import("../components/DateRangePicker.vue"),
  },
  props: {},
  data() {
    return {
      objKey: 0,
      mapTitle: "Delivery Map",
      curAgent: "",
      defaultEventColor: "grey",
      data_object: null,
      activeTab: 0,
      dateField: "etd_date",
      // coloredFields: ["trip_name"],
      link: {
        field: "shipment_id",
        name: "shipment"
      },
      mapData: [],
      dataTable: [],
      curWhs: {},
      permittedActions: null,
      agentFilter: false,
      mapLegend: {
        editRow: false,
        addButtonCaption: "Add New Trip",
        data_object: this.trip_data_object,
        getFreshData: true,
        directEdit: false,
        mobileBreakpoint: "0",
        itemsPerPage: "15",
        table_title: "Trips",
        tableName: "legend_trips",
        defaultModel: this.defaultModel,
        alwaysUpdate: true,
        calToolBarControls: [],
        // fields_excluded: "tripFieldsExcluded",
        singleSelect: true,
        noDelete: true,
        // rowClick: this.tripSelected,
        afterSave: this.tripAfterSave,
        fields_included: ["trip_name", "status"],
        // hideHeader: true,
        coloredFields: ["trip_name"],
        // getItemColor: function(e, slot, item, tableName) {
        //   // console.log(e, slot, item, tableName);
        //   return item.trip_name.color;
        // },
        noAlert: true,
        width: 3
      },
      tableName: "delivery_dispatch",
      editable: ["eta", "etd", "delivery_status", "next_stop", "trip", "trip_name"],
      // actionCommand: [
      //   {
      //     // icon: "mdi-truck-trailer",
      //     commandText: function(item) {
      //       return item.trip || "(Assign)";
      //     },
      //     text: "Trips",
      //     color: "primary",
      //     id: "trips",
      //   },
      // ],
      whsCombo: {
        label: "Select Warehouse",
        objName: "warehouse",
        ctlName: "whsCombo",
        itemText: "warehouse_name",
        itemValue: "_id",
        defaultIndex: 0,

        returnObject: true
      },
      tableDraggable: true,
      etaDateRange: null,
      etdDateRange: null,
      customSortItems: ["eta", "etd", "trip_name"],
      additionalModel: null,
      tripFields: [
        "_id",
        "color",
        "dest_warehouse",
        "etd",
        "haul_type",
        "orig_warehouse",
        "status",
        "trip_name",
        "trip_type",
        "agent",
        "num_jobs"
      ],
      updateLegend: false,
      editedItemTitle: ["first_name", "last_name"],
      table: null,
      filterTabsFn: {
        "v-bind": {
          objName: "delivery_status",
          caption: "status",
          value: "status",
          name: "delivery_status",
          sort: "sort_order",
          color: "color"
          // qry: { status: { $ne: "long_term_storage" } },
        }
      }
      // " var  p=[{caption:'Delivery Pending',name:'trip',value:'null',empty:true},{caption:'Ready for Delivery',name:'trip',value:'null',empty:true},{caption:'Trip Assigned',name:'trip',notEmpty:true,value:'null'}]; p",
    };
  },
  mounted() {
    // this.activeTab = 1;
    var that = this;
    this.whsCombo.onChange = function(c) {
      that.curWhs = c;
      that.updateWhs();
    };
    // this.actionCommand[0].action = this.viewTrips;
    this.permittedActions = this.$root.store.permittedActions;
    this.currentUser = this.$root.store.userData.email;
    if (this.permittedActions.filter_jobs) {
      this.agentFilter = true;
    }

    this.createTripDataObject();
    //tableItemChanged
    this.$root.$on("tableItemChanged", t => {
      if (t.tbl.tableName == "delivery_dispatch") {
        console.log(t.item);
      }
    });

    this.$root.$on("tableSelectionChanged", t => {
      if (t.tableName == "v_trip") {
        var curRec = fun.getParentByProperty(t, "openButtonTitle").parentModel;
        if (curRec) {
          curRec.trip = t.selected[0];
          that.updateTable({ item: curRec });
        }
      }
    });
    this.calToolBarControls = [
      {
        comp: "v-combo",
        id: "curWhs",

        model: this.curWhs,
        "v-bind": this.whsCombo
      }
    ];
    this.$root.$on("comboUpdated", c => {
      // console.log(c);
      if (c.ctlName == "whsCombo") {
        that.curWhs = c.model;
        that.updateWhs();

        // this.objKey = !this.objKey;
      }
    });
  },
  beforeDestroy() {},
  methods: {
    updateWhs() {
      var cal = this.$refs.calTblMap.$refs.calendar;
      if (cal) {
        cal.events = cal.originalEvents.filter(r => {
          r.warehouse_id == this.curWhs._id;
        });
        cal.calKey = !cal.calKey;
      }
    },
    viewTrips(item) {
      console.log(item);
    },
    calendarFilter(cal) {
      if (this.curWhs) {
        return cal.originalEvents.filter(r => {
          r.warehouse_id == this.curWhs._id;
        });
      } else {
        return cal.originalEvents;
      }
    },
    tripAfterSave(d, model) {
      if (model.trip_type == "w2w") {
        if (model.dest_warehouse) {
          this.warehouseToTrip(model.dest_warehouse, {
            _id: model._id,
            trip_name: model.trip_name,
            color: model.color,
            etd: model.etd
          });
        }
      }
      this.$refs.calTblMap.refresh(true);
    },
    warehouseToTrip(whs, trip) {
      var that = this;
      var sameWhs = [];
      this.dataTable
        .filter(r => {
          return r.warehouse_id == this.curWhs._id;
        })
        .forEach(r => {
          var nextItinerary = r.next_stop;
          if (nextItinerary.warehouse && nextItinerary.warehouse._id == whs._id) {
            if (!r.trip) {
              r.trip = {
                _id: r._id
              };
              sameWhs.push(r._id);
            }
          }
        });

      if (sameWhs.length) {
        var assignToAllWhs = function() {
          // that.filterData(trip, true);
          var etd = trip ? trip.etd : "";

          var data = {
            metadata: {
              object_name: "sit_schedule",
              ids: sameWhs
            },
            model: {
              trip: {
                _id: trip._id
              }
            }
          };
          if (etd) {
            data.model.etd = fun.formattedDateTime(etd, "8:00");
          }
          axios
            .post(that.serverURL + "/update_many", data, {
              withCredentials: true
            })
            .then(response => {
              that.$refs.calTblMap.refresh(true);
            });
        };
        // if (sameWhs.length > 1) {
        var msg =
          "Assign to " + sameWhs.length + " shipments going to the same warehouse - " + whs.warehouse_name + "?";
        this.$root.$confirm
          .open("Confirmation", msg, {
            color: "green"
          })
          .then(confirm => {
            if (confirm) {
              assignToAllWhs();
            }
          });
        // } else {
        //   assignToAllWhs();
        // }
      }
    },
    createTripDataObject() {
      this.trip_data_object = {
        object_name: "v_trip_no_route",
        schema_name: "v_trip",
        object_name_to_update: "trip",
        qry: {
          "orig_warehouse._id": this.curWhs._id
        },
        fields: this.tripFields,
        mobileBreakpoint: 0,
        get_table: "all",
        alwaysAddId: true,
        all_records: true,
        additional_data: [
          { obj_name: "warehouse" },
          { obj_name: "trip_status" },
          {
            obj_name: "v_sit_schedule",
            qry: {
              trip: { $ne: null }
            }
          }
        ],

        table_title: "Trips",
        hasSearch: true
      };

      this.mapLegend.data_object = this.trip_data_object;
      this.mapLegend.defaultModel = this.getTripDefaultModel();
      this.mapLegend.refreshAfterSubmit = true;
    },
    updateTableRecord(t) {
      var d = { add: [], update: [], delete: [] };
      var itineraryKey = "estimate." + t.item.estimate_key + ".shipment_service.0.itinerary";
      var itineraryUpdate = {};
      var isNew = false;
      var update = [
        {
          delivery_status: t.item.delivery_status,
          warehouse: t.item.warehouse,
          etd: t.item.etd,
          _id: t.item.itinerary_id,
          trip: t.item.trip
        }
      ];
      if (t.item.next_stop && Object.keys(t.item.next_stop).length) {
        if (!t.item.next_stop._id) {
          // t.item.next_stop._id = fun.guid();
          d.add = [t.item.next_stop];
          isNew = true;
        } else {
          update.push(t.item.next_stop);
          //
        }
      }
      // if (!t.item.itinerary_id) {
      //   update["step"] = "d2w";
      //   itineraryUpdate[itineraryKey] = update;
      //   isNew = true;
      //   //
      // } else {
      //   Object.keys(update).forEach((k) => {
      //     itineraryUpdate[itineraryKey + ".$." + k] = update[k];
      //   });
      // }

      // d[isNew ? "add" : "update"] = update;
      d.update = update;

      var updateData = {};
      updateData[itineraryKey] = {
        id_fields: ["agent._id", "itinerary._id", "warehouse._id", "_id"],
        update_data: d
      };
      var data = {
        metadata: { object_name: "shipment", update_only: true },
        update: updateData,
        model: { _id: t.item.cid },
        _id: t.item.cid
      };
      return data;
    },
    updateTable(t, f) {
      var that = this;
      var data = this.updateTableRecord(t);

      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(r => {
          if (f) {
            f(r);
          }
        });
    },
    // updateTable(t, f) {
    //   var that = this;
    //   this.table = this.$refs.calTblMap.$refs.dTable;
    //   var data = [];

    //   if (t.item.trip) {
    //     var trip = this.additionalModel.trip.filter((r) => {
    //       return r._id == t.item.trip._id;
    //     });
    //     if (!trip.length) {
    //       this.additionalModel.trip.push(t.item.trip);
    //     }
    //   }
    //   var etd = t.item.etd;
    //   if (t.item.trip) {
    //     etd = t.item.trip.etd;
    //   }
    //   // data.push({
    //   //   collection: "sit_schedule",
    //   //   qry: {
    //   //     _id: t.item._id,
    //   //   },

    //   //   update: {
    //   //     trip: t.item.trip,
    //   //     delivery_status: t.item.delivery_status,
    //   //     eta: t.item.eta,
    //   //     etd: etd,
    //   //   },
    //   // });
    //   // if (t.item.next_stop.crew.foreman) {
    //   data.push({
    //     collection: "shipment",
    //     // id_fields: ["estimate.non-binding.shipment_service.itinerary._id"],
    //     qry: {
    //       shipment_id: t.item.shipment_id,
    //       "estimate.non-binding.shipment_service.itinerary": {
    //         $elemMatch: { _id: t.item.itinerary_id },
    //       },
    //     },
    //     update: {
    //       // "estimate.non-binding.shipment_service.$[s].itinerary.$[i].crew.foreman":
    //       //   t.item.next_stop.crew.foreman,
    //       "estimate.non-binding.shipment_service.$[s].itinerary.$[i].etd":
    //         t.item.etd,
    //       "estimate.non-binding.shipment_service.$[s].itinerary.$[i].agent":
    //         t.item.agent,
    //       "estimate.non-binding.shipment_service.$[s].itinerary.$[i].delivery_status":
    //         t.item.delivery_status,
    //     },
    //     array_filters: [
    //       {
    //         "s._id": t.item.service_id,
    //       },
    //       {
    //         "i._id": t.item.itinerary_id,
    //       },
    //     ],
    //   });
    //   // }
    //   if (t.item.next_stop) {
    //     if (!t.item.next_stop._id) {
    //       t.item.next_stop._id = fun.guid();

    //       data[0].update[
    //         "estimate.non-binding.shipment_service.$[s].itinerary.$[n]"
    //       ] = t.item.next_stop;
    //       data[0].array_filters.push({
    //         "n._id": t.item.next_stop._id,
    //       });
    //     }
    //   }

    //   axios
    //     .post(this.serverURL + "/modify_value", data, {
    //       withCredentials: true,
    //     })
    //     .then((r) => {
    //       // this.$refs.calTblMap.refresh();
    //       that.table.doTabFilter();
    //       this.$root.$emit("mapDataChanged", {
    //         data: this.mapData,
    //         legend: this.mapLegend,
    //         updateLegend: true,
    //       });
    //     });
    //   if (t.item.delivery_status == "long_term_storage") {
    //     this.$root.addResentTab({
    //       storage_id: "0",
    //       sid: t.item.cid,
    //       name: "storage-detail",
    //       shipment: t.item,
    //       customer_id: t.item.customer._id,
    //     });
    //   }
    //   if (t.item.next_stop) {
    //     console.log(t);
    //     // var itinerary = curRec.itinerary;
    //     // if (
    //     //   itinerary[0].agent._id != t.item.agent._id ||
    //     //   itinerary[0].warehouse._id != t.item.warehouse._id ||
    //     //   t.item.foreman
    //     // ) {
    //     //   itinerary[0].agent = t.item.agent;
    //     //   itinerary[0].warehouse = t.item.warehouse;
    //     //   if (t.item.foreman) {
    //     //     if (!itinerary[0].crew) {
    //     //       itinerary[0].crew = {};
    //     //     }
    //     //     itinerary[0].crew.foreman = t.item.foreman;
    //     //   }

    //     //   model.itinerary = itinerary;
    //     //   model.shipment_id = curRec.shipment_id;
    //     //   model.estimate_key = curRec.estimate_key;
    //     //   model.service_id = curRec.service_id;

    //     //   axios.post(this.serverURL + "/update_itinerary", model, {
    //     //     withCredentials: true,
    //     //   });
    //     // }
    //   }
    // },
    linkClick: function(item) {
      item.first_name = item.customer.contact.first_name;
      item.last_name = item.customer.contact.last_name;
      this.$root.addResentTab(item);
    },

    getItemColor(e, slot, item, tableName) {
      var color = "";
      switch (slot) {
        case "trip":
          if (e) {
            try {
              color = e.color;
            } catch (error) {
              console.log(error);
            }
          }
          break;
        case "trip_name":
          if (e) {
            try {
              color = this.additionalModel.trip.filter(t => {
                return t.trip_name == e;
              })[0].color;
            } catch (error) {
              // console.log(error);
            }
          }
          break;

        default:
          break;
      }
      return color;
    },
    legendFilter(r) {
      if (r.orig_warehouse) {
        return r.orig_warehouse._id == this.curWhs._id;
      } else {
        var trip = this.additionalModel.trip.filter(t => {
          return t._id == r._id;
        })[0];
        return trip && trip.orig_warehouse && trip.orig_warehouse._id == this.curWhs._id && trip.status == "scheduled";
      }
    },
    getTripDefaultModel() {
      this.defaultModel = {
        _id: fun.guid(),
        orig_warehouse: this.curWhs,
        status: "scheduled",
        haul_type: "internal",
        num_job: 0
      };
      this.mapLegend.defaultModel = this.defaultModel;
      return this.defaultModel;
    },
    eventTemplate: function(e, data, obj) {
      var serviceDate = new Date(e.etd);

      var endTime = serviceDate.addHours(1);
      var ev;
      if (e.etd) {
        var isEta = e.eta ? "dropoff" : "pickup";
        try {
          ev = {
            name: e.shipment_id.toString() + " " + isEta,
            start: fun.formatDateTime(e.etd),
            shipment_id: e.shipment_id,
            end: fun.formatDateTime(endTime),
            timed: false,
            first_name: e.customer.contact.first_name,
            last_name: e.customer.contact.last_name,
            color: e.eta ? "grey" : e.trip ? e.trip.color : ""
          };

          return ev;
        } catch (error) {
          console.log(e);
        }
      }

      return ev;
    },

    getDataObject(tbl) {
      if (this.curWhs._id) {
        var data_object = {
          object_name: "v_schedule_cal",
          schema_name: "v_sit_schedule",

          qry: { "warehouse._id": this.curWhs._id },
          date_fields: ["etd_date"],
          mobileBreakpoint: 0,
          // id_fields: ["warehouse._id"],
          // fields_excluded: ["route"],
          get_table: "all",
          additional_data: [
            {
              obj_name: "trip",
              fields: this.tripFields
            },
            { obj_name: "warehouse" },
            { obj_name: "trip_status" }
          ],
          aggregate_variables: {},
          item_key: "shipment_id",
          table_title: "SIT",
          hasSearch: true
        };
        if (this.agentFilter) {
          data_object.qry.agent = { $exists: true };

          data_object.qry["agent.contact.email"] = this.$root.store.userData.email;
        }

        // if (this.permittedActions.filter_jobs) {
        //   data_object.qry = {
        //     "warehouse_id._id": this.curWhs._id,

        //     agent: { $exists: true },

        //     "agent.contact.email": this.$root.store.userData.email,
        //   };
        //   console.log(JSON.stringify(data_object.qry));
        // }
        return data_object;
      }
    },

    onMarkerClick(data, e) {
      var topElement = e.target.closest(".map-outer").getElementsByClassName("map-top")[0];
      var innerElement = e.target.closest(".map-outer").getElementsByClassName("map-inner")[0];

      this.markerWarehouseClick(data, innerElement, topElement);
    },
    assignTrip(data, trip, unassign) {
      // var model = {};
      var d = {
        metadata: {
          object_name: "sit_schedule"
        }
      };
      var model = {
        _id: data.id,
        etd: unassign ? "" : trip.etd,
        trip: unassign
          ? ""
          : {
              _id: trip._id
            }
      };
      d.model = model;
      this.updateTable({ item: model });
    },
    markerWarehouseClick(data, innerElement, topElement) {
      var that = this;

      var unassign = false;
      var msg = "";

      var trip = data.legend.selected[0];
      if (!trip) {
        this.$root.alertDialog("No Trips Selected", "Please select a trip on the right to assign");
        return;
      }
      if (trip && topElement && topElement.innerHTML == trip._id) {
        unassign = true;
      }
      if (data.delivery_date_range && data.delivery_date_range.split("-")[1]) {
        msg = this.checkDeliveryDate(trip, data);
      }

      // msg = "Confirm assigning " + trip.trip_name + " to " + data.label + "?";

      if (unassign) {
        msg = "Confirm unassigning " + data.label + "?";
      }
      if (msg) {
        this.$root.$confirm
          .open("Confirmation", msg, {
            color: "green"
          })
          .then(confirm => {
            if (confirm) {
              // console.log("assigned");
              this.assignTrip(data, trip);
            }
          });
      } else {
        this.assignTrip(data, trip, unassign);
      }
    },
    checkDeliveryDate(trip, curRec) {
      if (!trip) {
        return;
      }
      var msg = "";
      if (trip._id && curRec.trip && curRec.trip._id == trip._id) {
        return 0;
      }
      if (curRec.delivery_date_range && new Date(curRec.delivery_date_range.split("-")[1]) < new Date(trip.etd)) {
        msg =
          "Trip " +
          trip.trip_name +
          " departs at " +
          fun.formatDate(trip.etd) +
          ", however the latest delivery date of this shipment is " +
          fun.formatDate(curRec.delivery_date_range.split("-")[1]) +
          ".\nYou still want to assign this trip to the shipment?";
        return msg;
      } else if (curRec.eta && new Date(curRec.eta) > new Date(trip.etd)) {
        msg =
          "Trip " +
          trip.trip_name +
          " departs at " +
          fun.formatDate(trip.etd) +
          ", however the arrival date of this shipment is " +
          fun.formatDate(curRec.eta) +
          ".\nYou still want to assign this trip to the shipment?";
        return msg;
      } else {
        return "";
      }
    },
    updateForemanOnMap(data, topElement) {
      var curForeman = this.foreman.filter(f => {
        return f._id == data.foreman._id;
      });
      if (curForeman[0]) {
        topElement.innerHTML = curForeman[0].employee_id;
        topElement.style.backgroundColor = curForeman[0].color;
        topElement.style.display = "block";
      }
    },
    eventClick(e) {
      this.linkClick(e.event);
    },
    getLocation(r, stopType) {
      var stops = r.stops;
      var st = stops.filter(s => {
        return s.address_type == stopType;
      })[0];
      if (st) {
        var location = r.customer.address.filter(a => {
          return a.full_address == st.full_address;
        })[0];
        if (location && location.location.address.geo) {
          location = location.location.address.geo;
        }
        return location;
      }
    },
    getWarehouseMarker(r, whsFrom, trip) {
      var whsId = r.warehouse_id;
      if (r.next_stop && !whsFrom) {
        whsId = r.next_stop.warehouse._id;
      }
      var whs = this.additionalModel.warehouse.filter(w => {
        return w._id == whsId;
      });
      if (
        whs.length &&
        !this.mapData.filter(m => {
          return m.label == whs[0].warehouse_name;
        }).length
      ) {
        var whsColor = whs[0].color;
        var borderColor = "";
        var tripColor = "";
        if (whs[0].geo && whs[0].address) {
          if (parseFloat(whs[0].geo.position[0]) && parseFloat(whs[0].geo.position[1])) {
            if (r.trip) {
              var topElementValue = "";
              var topElementColor = "";
              var curTrip = this.additionalModel.trip.filter(t => {
                return t._id == r.trip._id;
              })[0];
              if (!curTrip || !curTrip.trip_name) {
                curTrip = trip;
              }
              if (curTrip) {
                if (whs[0]._id != r.warehouse_id) {
                  // topElementValue = curTrip.trip_name.substring(0, 5);
                  // topElementColor = curTrip.color;
                  // whsColor = curTrip.color;
                  tripColor = curTrip.color;
                }
              }
            }
          }
          this.mapData.push({
            pos: {
              lat: whs[0].geo.position[0],
              lng: whs[0].geo.position[1]
            },
            label: whs[0].warehouse_name,
            address: whs[0].address.address,
            shortLabel: '<div class="mdi mdi-forklift"></div>',
            warehouseId: whs[0]._id,
            markerColor: curTrip ? tripColor : whsColor,
            // color: curTrip ? tripColor : "white",
            extraClass: whsFrom ? ["square-selected"] : curTrip ? ["romb"] : ["square"],
            topElementValue: topElementValue,
            topElementColor: topElementColor,
            id: !whsFrom ? r._id : ""
          });
        }
      }
    },
    createWarehouseMapData(r, trip) {
      this.getWarehouseMarker(r, true, trip);

      if (r && r.destination && r.next_stop) {
        if (r.next_stop.step == "w2d") {
          // var location = this.getLocation(r, "dropoff");
          var location = r.destination.address;
          if (r.destination && r.destination.position) {
            var pos = r.destination.position;

            if (pos && parseFloat(pos[0]) && parseFloat(pos[1])) {
              var label = r.first_name + " " + r.last_name + " #" + r.shipment_id;
              if (r.delivery_date_range) {
                label += "\nDelivery Dates: " + r.delivery_date_range;
              }
              var shortLabel = '<div class="mdi mdi-home-circle"></div>';
              var markerColor = this.defaultEventColor;
              var color = "white";
              var trip_id;
              var topElementValue = "";
              var topElementColor = "";
              if (r.trip) {
                trip_id = r.trip._id;
                var curTrip = this.additionalModel.trip.filter(t => {
                  return t._id == r.trip._id;
                })[0];
                if (!curTrip) {
                  curTrip = trip;
                } else {
                  markerColor = curTrip.color;
                  topElementValue = curTrip.trip_name.substring(0, 3);
                  topElementColor = curTrip.color;
                }
              }
              this.mapData.push({
                pos: {
                  lat: pos[0],
                  lng: pos[1]
                },
                label: label + "\n" + location.city + ", " + location.stateCode,
                address: location.label,
                shortLabel: shortLabel,
                markerColor: markerColor,
                delivery_date_range: r.delivery_date_range,
                color: color,
                id: r._id,
                trip_id: trip_id,
                // topElementValue: topElementValue,
                // topElementColor: topElementColor,
                extraClass: topElementValue ? ["romb"] : []
              });
            }
          }
        }
        if (r.next_stop.step == "w2w") {
          // console.log(r);
          this.getWarehouseMarker(r, false, trip);
        }
      }
    },
    customFilter(value, search, item) {
      search = search.toLowerCase();
      var trip =
        item.trip &&
        this.additionalModel.trip.filter(f => {
          return f._id == item.trip._id;
        })[0];
      var destination =
        item.itinerary && item.nextItineraryIndex && item.itinerary[item.nextItineraryIndex]
          ? item.itinerary[item.nextItineraryIndex]
          : "";
      var whs =
        item.itinerary &&
        item.nextItineraryIndex &&
        item.itinerary[item.nextItineraryIndex] &&
        item.itinerary[item.nextItineraryIndex].warehouse
          ? item.itinerary[item.nextItineraryIndex].warehouse.warehouse_name
          : "";
      return (
        (value != null &&
          search != null &&
          typeof value === "string" &&
          value
            .toString()
            .toLowerCase()
            .indexOf(search) !== -1) ||
        (trip && trip.trip_name.toLowerCase().indexOf(search) !== -1) ||
        (destination && destination.step && destination.step.toLowerCase().indexOf(search) !== -1) ||
        (destination && destination.destination && destination.destination.toLowerCase().indexOf(search) !== -1) ||
        (whs && whs.toLowerCase().indexOf(search) !== -1)
      );
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        // if (index[0] == "trip") {
        var s = false;
        switch (index[0]) {
          case "trip_name":
            var tripNameA = "";
            var tripNameB = "";
            if (a["trip_name"]) {
              tripNameA = a[index] ? a[index] : "";
            }
            if (b["trip_name"]) {
              tripNameB = b[index] ? b[index] : "";
            }

            if (!isDesc[0]) {
              s = tripNameA
                .toString()
                .toLowerCase()
                .localeCompare(tripNameB.toString().toLowerCase());
            } else {
              s = tripNameB
                .toString()
                .toLowerCase()
                .localeCompare(tripNameA.toString().toLowerCase());
            }
            break;
          case "eta":
          case "etd":
            try {
              var dateA = a[index].toString().trim() ? new Date(a[index].toString().trim()) : new Date("1/1/1900");
              var dateB = b[index].toString().trim() ? new Date(b[index].toString().trim()) : new Date("1/1/1900");
              if (!isDesc[0]) {
                s = dateA - dateB;
              } else {
                s = dateB - dateA;
              }
            } catch (error) {
              //
            }

            break;

          default:
            break;
        }
        return s;
      });
      return items;
    },
    onDataReceived(data, d, feedback) {
      // console.log(data);
      var that = this;

      this.createTripDataObject();
      // var tripObject = data.schema.properties.trip_name["v-bind"];
      // tripObject.data_object.qry = this.trip_data_object.qry;
      // tripObject.defaultModel = this.getTripDefaultModel();

      this.mapData = [];
      this.mapReady = false;
      this.additionalModel = data.additional_model;
      data.model?.forEach(m => {
        if (!m.delivery_status) {
          m.delivery_status = "pending";
        }
        if (m.trip) {
          m.delivery_status = "trip_assigned";
        }
      });
      if (d) {
        // var serviceDate = fun.getFullDate(d);
        // this.dataTable = data.model.filter((m) => {
        //   return fun.getFullDate(new Date(m.date)) == serviceDate;
        // });

        this.dataTable.forEach(r => {
          this.createWarehouseMapData(r);
        });
        this.$root.$emit("mapDataChanged", {
          data: this.mapData,
          legend: this.mapLegend,
          updateLegend: true
        });
        this.mapReady = true;
      } else {
        this.dataTable = data.model;
      }
      return this.dataTable;
      // } else {
      //   var sitData = this.getDataObject();
      //   axios
      //     .post(this.serverURL + "/get_data", sitData, {
      //       withCredentials: true,
      //     })
      //     .then((response) => {
      //       // console.log(response.data);
      //       this.dataTable = response.data.model;
      //       this.dataTable.forEach((d) => {
      //         if (!d.delivery_status) {
      //           d.delivery_status = "scheduled";
      //         }
      //         if (d.trip) {
      //           d.delivery_status = "trip_assigned";
      //         }
      //         this.createWarehouseMapData(d);
      //         if (d.next_stop && !d.next_stop.crew) {
      //           d.next_stop.crew = {};
      //         }
      //       });
      //       that.$root.$emit("mapDataChanged", {
      //         data: that.mapData,
      //         legend: that.mapLegend,
      //         updateLegend: this.updateLegend,
      //       });
      //       this.updateLegend = false;
      //       if (feedback) {
      //         feedback(this.dataTable);
      //       }
      //     });
      // }
    },

    replaceColor(obj) {
      var classes = "";
      if (obj) {
        obj.forEach(s => {
          try {
            if (s.color && s.color.replace) {
              if (s.color.length == 9 && s.color[0] == "#") {
                s.color = s.color.substr(0, 7);
              }
              var className = "color-" + s.color.replace("#", "");
              var classCss = "background-color:" + s.color + "; color:" + "white";
              // fun.invertColor(s.color);
              var cl = "\n." + className + " { " + classCss + "}";
              if (classes.indexOf(cl) == -1) {
                classes += cl;
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
        this.$root.dynamicClasses(classes);
      }
    }
  },
  watch: {
    curWhs() {
      if (this.curWhs) {
        this.updateLegend = true;
        this.$refs.calTblMap.refresh(true);
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
